import axios, { AxiosRequestConfig } from "axios";
import ApiTokenApiRequest from "./apiTokenApiRequest";

// APIリクエストのリクエスト本体
export default class ApiRequestBase {
	/**
	 * GETリクエスト。
	 * @param options AxiosRequestConfig
	 * @returns
	 */
	public static async request<T>(options: AxiosRequestConfig): Promise<T | T[]> {
		/* 
			将来、キャッシュ機構など事前処理を挟む必要がある場合に
			この辺に処理を差し込む
		*/
		try {
			const result = await axios(options);
			return result.data;
		} catch (error) {
			// axios型のエラーオブジェクトであれば型推論が効くので、それで対応
			if (axios.isAxiosError(error)) {
				console.error(`apiRequestBase.request error:
status:  ${error.response?.status}
requestUrl: ${error.response?.config.url}`);
				throw error.response?.data;
			}

			// そうでなければとりあえずエラー内容全てをThrow
			throw error;
		}
	}

	/**
	 * POSTリクエスト。
	 * @param options AxiosRequestConfig
	 * @returns
	 */
	public static async requestWithApiToken<T>(tenantId: string, options: AxiosRequestConfig): Promise<T | T[]> {
		/* 
			キャッシュ機構など事前処理を挟む必要がある場合に
			この辺に処理を差し込む
		*/

		try {
			// ApiTokenをheaderへセット
			const apiTokenApiRequest = new ApiTokenApiRequest();
			const apiTokenGetResponse = await apiTokenApiRequest.getApiToken(tenantId);
			options.headers = {
				...options.headers,
				[apiTokenGetResponse.name]: apiTokenGetResponse.token,
			};

			const result = await axios(options);
			return result.data;
		} catch (error) {
			// axios型のエラーオブジェクトであれば型推論が効くので、それで対応
			if (axios.isAxiosError(error)) {
				console.error(`apiRequestBase.requestWithApiToken error:
status: ${error.response?.status}
requestUrl: ${error.response?.config.url}`);
				throw error.response?.data;
			}

			// そうでなければとりあえずエラー内容全てをThrow
			throw error;
		}
	}
}
